import * as React from "react"
import { css } from "../utils"

export const Card = React.forwardRef(
  ({ ...props }: React.HTMLAttributes<HTMLDivElement>, ref: any) => (
    <div
      {...props}
      ref={ref}
      className={css(
        props.className,
        "shadow-lg p-8 rounded bg-gray-800 text-gray-200"
      )}
    />
  )
)
